import { gql } from '@apollo/client';

const GET_APPRAISAL_COMPARISON_ORG_UNIT = gql`
  query GetAppraisalComparisonOrgUnit($id: Int!) {
    appraisalComparisonOrgUnit(id: $id) {
      Id
      Name
      IsActive
      Fei
      Address1
      Address2
      City
      State
      ZipCode
      EnrollmentDate
      MddapOrganization {
        Name
      }
      AppraisalOrgUnits {
        Id
        Name
        Appraisal {
          Id
          ConductAppraisalEndDate
          AppraisalOrgUnits {
            Id
            Name
            AppraisalOrgUnitProjects {
              Id
              Name
              Description
            }
            MddapOrgUnitId
            IsUserHasAccessOrgUnit
          }
          AppraisalTeamMembers {
            Individual {
              Id
              Name
            }
            Type
          }
        }
        AppraisalOrgUnitTargetPracticeAreas {
          Id
          AggregatePercentage
          PracticeArea {
            Id
            Name
            Acronym
          }
          PracticeGroup {
            Id
            Level
          }
        }
        AppraisalProgramYear
        IsSharedWithFda
        ShowPracticeCharacterizationForUnit
      }
      MddapOfficeOfHealthTechnologies {
        Id
        OfficeOfHealthTechnology {
          Id
          Value
        }
      }
    }
    isPercentageVisible(orgUnitId: $id, reportName: "appraisal-comparison")
  }
`;

export default GET_APPRAISAL_COMPARISON_ORG_UNIT;
